import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconOnboarding = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M12 2C6.48571 2 2 6.48571 2 12C2 17.5143 6.48571 22 12 22C17.5143 22 22 17.5143 22 12C22 6.48571 17.5143 2 12 2ZM12.7143 20.5349V19.1429C12.7143 18.7483 12.3947 18.4286 12 18.4286C11.6053 18.4286 11.2857 18.7483 11.2857 19.1429V20.5349C7.12937 20.1902 3.80983 16.8706 3.46514 12.7143H4.8571C5.25175 12.7143 5.57138 12.3947 5.57138 12C5.57138 11.6053 5.25175 11.2857 4.8571 11.2857H3.46514C3.80978 7.12937 7.12937 3.80983 11.2857 3.46514V4.8571C11.2857 5.25175 11.6053 5.57138 12 5.57138C12.3947 5.57138 12.7143 5.25175 12.7143 4.8571V3.46514C16.8706 3.80978 20.1902 7.12937 20.5349 11.2857H19.1429C18.7483 11.2857 18.4286 11.6053 18.4286 12C18.4286 12.3947 18.7483 12.7143 19.1429 12.7143H20.5349C20.1902 16.8706 16.8706 20.1902 12.7143 20.5349ZM15.5643 7.95634L9.93669 9.17867C9.68937 9.23225 9.48848 9.41259 9.4099 9.65278L7.60633 15.1216C7.52508 15.3653 7.58222 15.6332 7.75365 15.8234C7.89026 15.9751 8.08401 16.06 8.2849 16.06C8.3349 16.06 8.38579 16.0546 8.43668 16.0439L14.0643 14.8216C14.3117 14.768 14.5125 14.5877 14.5911 14.3475L16.3947 8.87867C16.4759 8.63492 16.4188 8.36706 16.2474 8.17689C16.0759 7.98671 15.8161 7.90456 15.5643 7.95634ZM9.35451 14.3822L10.3813 11.2688L12.5581 13.6866L9.35451 14.3822ZM13.6197 12.7313L11.4429 10.3134L14.6465 9.6179L13.6197 12.7313Z" />
      </svg>
    );
  }
);
